import { render } from "./DateNameFilter.vue?vue&type=template&id=b984d032&scoped=true&ts=true"
import script from "./DateNameFilter.vue?vue&type=script&lang=ts"
export * from "./DateNameFilter.vue?vue&type=script&lang=ts"

import "./DateNameFilter.vue?vue&type=style&index=0&id=b984d032&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b984d032"]])

export default __exports__